export default {
  breadcrumb: '面谈详情',
  title: '{name} 的面谈',
  aiInterview: 'AI 面谈',
  manualInterview: '人工面谈',
  tabs: {
    video: '面谈视频',
    result: '面谈结果',
    summary: '面谈纪要',
  },
  updater: '更新者',
  updateTime: '更新日時',
  download: '下载',
  reupload: '重新上传',
  upload: '上传',
  uploadTip: '限 MP4/MKV/AVI 格式、单个文件需小于 1 GB。',
  videoProcessing: '视频已上传，正在处理中，请稍后刷新查看。',
  refresh: '刷新',
  noVideo: '暂无面谈视频',
  uploadSuccess: '上传成功',
  durationFormat: '{minutes}分{seconds}秒',
  empty: '暂无内容',
  uploadDialog: {
    title: '上传面谈视频',
    description: '上传视频后，同时自动执行以下选中的任务：',
    generateResult: '自动生成/更新面谈结果',
    generateSummary: '自动生成/更新面谈纪要',
  },
  result: {
    title: '面谈结果',
    updateFromVideo: '基于面谈视频更新',
    edit: '编辑面谈结果',
    uploadVideoFirst: '请先上传面谈视频',
    overwriteTitle: '基于面谈视频更新面谈结果',
    overwriteContent: '确认后将覆盖之前的面谈结果，确认是否继续？',
    continue: '继续',
    generating: '正在基于面谈视频生成…',
    jobCommunication: '职位沟通',
    agreeApply: '同意投递',
    notConsider: '暂不考虑',
    pending: '待确认意向',
    japanese: '日语能力',
    bc: 'BC 能力',
    score: '评分',
    strengths: '优势',
    suggestions: '改善建议',
    invalidJobId: '求人 ID 格式不正确：{ids}',
  },
  summary: {
    title: '面谈纪要',
    edit: '编辑面谈纪要',
    overwriteTitle: '基于面谈视频更新面谈纪要',
    overwriteContent: '确认后将覆盖之前的面谈纪要，确认是否继续？',
  },
  player: {
    switchTimeMode: '切换时间展示方式',
    backward: '后退 15 秒',
    forward: '前进 15 秒',
    play: '播放',
    pause: '暂停',
    subtitle: '字幕',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
  },
}
